import Grid from '@mui/material/Grid2';
import { StoreDetailsSettings } from './StoreDetailsSettings';

export const StoreSettings = () => {
  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, lg: 6 }}>
        <StoreDetailsSettings />
      </Grid>
    </Grid>
  );
};
